import { MODULES, type ModuleId } from './modules';

export type OverrideMode = 'default' | 'forced_on' | 'forced_off';

export interface ModuleAccessInput {
  moduleId: ModuleId;
  /** The user's own toggle (module_states.enabled). */
  enabled: boolean;
  /** The admin override (module_overrides.mode), 'default' when there is no row. */
  override: OverrideMode;
  /** app_settings.billing_live. */
  billingLive: boolean;
  /** The user has paid for this module, or it is free. */
  paidOrFree: boolean;
}

/**
 * Spec §7 "Rule for module access":
 * - forced_off always wins.
 * - forced_on grants the module.
 * - default: an always-on module (Today, To-do) is usable; any other module is usable when the
 *   user enabled it and, once billing is live, has paid for it or it is free.
 */
export function isModuleUsable(args: ModuleAccessInput): boolean {
  if (args.override === 'forced_off') return false;
  if (args.override === 'forced_on') return true;
  if (MODULES[args.moduleId].alwaysOn) return true;
  return args.enabled && (!args.billingLive || args.paidOrFree);
}
